import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './plugins/i18n';
import vuetify from './plugins/vuetify';
import './plugins/toasted';
import './plugins/tippy';
import axios, {AxiosInstance} from 'axios';
import {api, ApiInterface} from '@/configs/ApiConfig';
import '@mdi/font/css/materialdesignicons.min.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import './sass/index.scss';
import './sass/v-tippy__google.scss';
import {store} from './store';

Vue.config.productionTip = false;

export const httpClient = axios.create({
    baseURL: '/',
});

declare module 'vue/types/vue' {
    interface Vue {
        $api: ApiInterface;
        $http: AxiosInstance;
    }
}

Object.defineProperties(Vue.prototype, {
    $api: {
        get() {
            return api;
        },
    },
    $http: {
        get() {
            return httpClient;
        },
    },
});

new Vue({
    router,
    i18n,
    vuetify,
    store,
    render: h => h(App),
}).$mount('#app');
